/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_CopyInputs */

const en_road_dude_prompt_copy = /** @type {(inputs: Road_Dude_Prompt_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy prompt`)
};

const zh_road_dude_prompt_copy = /** @type {(inputs: Road_Dude_Prompt_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制提示词`)
};

/**
* | output |
* | --- |
* | "Copy prompt" |
*
* @param {Road_Dude_Prompt_CopyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_copy = /** @type {((inputs?: Road_Dude_Prompt_CopyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_CopyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_copy(inputs)
	return zh_road_dude_prompt_copy(inputs)
});
export { road_dude_prompt_copy as "road_dude.prompt.copy" }